import IParser from "@/types/IParser"
import { IDcaConfiguration } from "./dcaConfiguration.types"
import ParseError from "@/types/ParseError"
import { DcaConfiguration } from "./dcaConfiguration"

export interface IDcaConfigurationRaw {
  dca: string
  junifer_ticket_definition: string
}

export const DcaConfigurationParser: IParser<
  IDcaConfiguration,
  IDcaConfigurationRaw
> = {
  toDomain: (data: IDcaConfigurationRaw) => {
    try {
      return new DcaConfiguration(data.dca, data.junifer_ticket_definition)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
